import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CasesComponent } from "./dashboard/cases/cases.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { LoginComponent } from "./login/login.component";
import { TwofaFormComponent } from "./login/twofa-form/twofa-form.component";
import { AuthGuardService } from "./services/auth-guard/auth-guard.service";
import { translateTitle as resolveTranslateTitle } from './shared/services/title/translate-title.resolver';
import { withTestTitlePrefix } from './shared/services/title/with-test-title-prefix.resolver';

const translateTitle = (key: string) => withTestTitlePrefix(resolveTranslateTitle(key));

const routes: Routes = [
  { path: 'login', component: LoginComponent, title: translateTitle('BROWSER_TITLES.LOGIN') },
  {
    path: '2fa',
    children: [
      { path: '', redirectTo: 'verify', pathMatch: 'full' },
      {
        path: 'verify',
        component: TwofaFormComponent,
        title: translateTitle('BROWSER_TITLES.TWO_FACTOR'),
      },
    ],
  },
  {
    path: 'attorney',
    component: DashboardComponent,
    canActivate: [AuthGuardService],
    title: translateTitle('BROWSER_TITLES.ATTORNEY'),
    children: [
      { path: 'cases', component: CasesComponent },
      { path: '**', redirectTo: 'cases' },
    ],
  },
  { path: '**', redirectTo: 'attorney' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
